import React from "react";
import { Link } from "react-router";
import Select from "react-select";
import axios from "axios";
import ChapterProgress from "../../components/ChapterProgress";
import FormErrorHandler from "../../components/FormErrorHandler";

export default class competenceprofilesBundles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dirtyForm: false,
            content_editable: null,
            errorMessage: "",
            competenceprofile: false,
            bundles: [],
            selectedCompetences: [],
            selectedMeasurements: [],
            selectedBundles: [],
            changeBundles: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitPrevious = this.handleSubmitPrevious.bind(this);
        this.filterCurrentData = this.filterCurrentData.bind(this);
        this.changeBundle = this.changeBundle.bind(this);
    }

    handleSubmitPrevious(e) {
        e.preventDefault();

        // Save the current data and go back to the overview
        let followUrl = "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements";
        this.setState({
            followUrl
        });

        if (this.state.content_editable !== false) {
            this.updateCompetenceprofile();
        } else {
            this.props.router.push(followUrl);
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        // Save the current data and continue to the competences
        let followUrl = "/competenceprofiles/edit/" + this.props.params.itemID + "/resume";
        this.setState({
            followUrl
        });

        if (this.state.content_editable !== false) {
            this.updateCompetenceprofile();
        } else {
            this.props.router.push(followUrl);
        }
    }

    changeBundle(bundleID) {
        let newBundle = [...this.state.changeBundles, bundleID];
        this.setState({
            changeBundles: newBundle
        });
    }

    updateCompetenceprofile() {
        // Build up the postdata based on the data we have in state
        let postData = [];
        for (const [key, value] of Object.entries(this.state.selectedCompetences)) {
            postData = [
                ...postData,
                {
                    uuid: key,
                    competences: value.map((comp) => {
                        return {
                            uuid: comp.value,
                            measurements: this.state.selectedMeasurements[comp.value].map((meas) => {
                                return {
                                    uuid: meas.value,
                                    bundle: this.state.selectedBundles[comp.value + meas.value] != undefined ? this.state.selectedBundles[comp.value + meas.value] : null
                                };
                            })
                        };
                    })
                }
            ];
        }

        axios
            .put("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/", postData)
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De toetsbundels onder competentieprofiel '${this.state.competenceprofile.name}' zijn succesvol opgeslagen`,
                    link: `/competenceprofiles/edit/${this.props.params.itemID}/bundles`
                });
                this.props.router.push(this.state.followUrl);
            })
            .catch((error) => {
                this.setState({
                    errorMessage: error.response.data
                });
            });
    }

    filterCurrentData() {
        if (this.state.competenceprofileData) {
            // First-clear the current state and prefill with selected data
            let selectedEndterms = [];
            let selectedCompetences = {};
            let selectedMeasurements = {};
            let selectedBundles = {};
            let i = 0;

            // Filter the currently selected items
            this.state.competenceprofileData.forEach((et) => {
                selectedEndterms.push(et);

                // Also make sure we get all the subselected competences and prefill the selector elements
                let newComp = [];
                et.competences.forEach((comp) => {
                    // Get all the subselected measurements as well
                    newComp.push({
                        value: comp.uuid,
                        label: comp.name
                    });

                    let newMeasurement = [];
                    comp.measurements.forEach((meas) => {
                        newMeasurement.push({
                            value: meas.uuid,
                            label: meas.name
                        });

                        // Get the selected bundles for each measurement
                        selectedBundles = {
                            ...selectedBundles,
                            [comp.uuid + meas.uuid]: meas.bundle == undefined || meas.bundle == null ? null : meas.bundle.uuid
                        };
                    });

                    selectedMeasurements = {
                        ...selectedMeasurements,
                        [comp.uuid]: newMeasurement
                    };
                });

                // Set the new state with these items
                selectedCompetences = {
                    ...selectedCompetences,
                    [et.uuid]: newComp
                };
            });

            this.setState({
                selectedEndterms,
                selectedBundles,
                selectedCompetences,
                selectedMeasurements
            });
        }
    }

    handleBundleOptionsChange(val, parentId) {
        let newState = {
            ...this.state.selectedBundles,
            [parentId]: val != null ? val.value : null
        };

        this.setState({
            selectedBundles: newState,
            dirtyForm: true
        });
    }

    componentDidMount() {
        axios
            .all([
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/"),
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/"),
                axios.get("/v1/measurementbundles/?is_active=1&fields=uuid,name&pagination=false")
            ])
            .then(
                axios.spread((cp, cpData, measurementBundles) => {
                    this.setState({
                        competenceprofile: cp.data,
                        content_editable: cp.data.content_editable,
                        competenceprofileData: cpData.data,
                        bundles: measurementBundles.data.map((item) => {
                            return {
                                value: item.uuid,
                                label: item.name
                            };
                        })
                    });
                    this.filterCurrentData();
                })
            )
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let bundleRows = [];
        if (!this.state.competenceprofileData) {
            return (
                <div>
                    <div className="section-top">
                        <h1>Ophalen van alle details...</h1>
                    </div>
                </div>
            );
        } else {
            this.state.competenceprofileData.forEach((et) => {
                // Show endterm title
                bundleRows.push(
                    <h2 key={"et-" + et.uuid}>
                        Eindterm: <strong>{et.name}</strong>
                    </h2>
                );

                et.competences.forEach((comp) => {
                    // Show competence title
                    bundleRows.push(
                        <h3 key={"comp-" + et.uuid + "-" + comp.uuid}>
                            Competentie: <strong>{comp.name}</strong>
                        </h3>
                    );

                    // Check for measurements and render these
                    if (comp.measurements.length == 0) {
                        bundleRows.push(
                            <div className="row" key={"measurements-" + et.uuid + "-" + comp.uuid + "-0"}>
                                <div className="col-6 measurement-field">
                                    <h4>Geen onder deze competentie</h4>
                                </div>
                            </div>
                        );
                    }
                    comp.measurements.forEach((meas) => {
                        let bundle = "Toetsbundel: Ongebundeld";

                        let findBundle = this.state.bundles.find((bundle) => bundle.value == this.state.selectedBundles[comp.uuid + meas.uuid]);
                        if (findBundle !== undefined) {
                            bundle = `Toetsbundel: ${findBundle.label}`;
                        }

                        bundle = (
                            <div>
                                {bundle}
                                {this.state.content_editable == false ? (
                                    ""
                                ) : (
                                    <i className="measurementbundle-change fa fa-pencil" onClick={() => this.changeBundle(comp.uuid + meas.uuid)}></i>
                                )}
                            </div>
                        );

                        // Check if the user wnats to change this bundle, if so, show other HTML
                        if (this.state.changeBundles.includes(comp.uuid + meas.uuid)) {
                            bundle = (
                                <Select
                                    {...window.selectDefaults}
                                    name="bundles"
                                    value={this.state.selectedBundles[comp.uuid + meas.uuid]}
                                    options={this.state.bundles}
                                    onChange={(val) => this.handleBundleOptionsChange(val, comp.uuid + meas.uuid)}
                                    required={false}
                                    placeholder="Ongebundeld"
                                    className="full-width-labels hidden"
                                    closeOnSelect={true}
                                    disabled={this.state.content_editable === false}
                                    readOnly={this.state.content_editable === false}
                                />
                            );
                        }

                        bundleRows.push(
                            <div className="row" key={"measurement-" + et.uuid + "-" + comp.uuid + "-" + meas.uuid}>
                                <div className="col-6 measurement-field">
                                    <h4>
                                        {meas.type === "knowledge" ? "Kennis: " : ""}
                                        {meas.type === "knowledge-exam" ? "Theorietoets: " : ""}
                                        {meas.type === "elearning" ? "E-learning: " : ""}
                                        {meas.type === "practice" ? "Praktijk: " : ""}
                                        <strong>{meas.name}</strong>
                                    </h4>
                                </div>
                                <div className="col-6 measurementbundle-field">{bundle}</div>
                            </div>
                        );
                    });
                });
            });
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>
                        <strong>{this.state.competenceprofile.name}</strong>
                    </h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={this.state.dirtyForm}
                        activeChapter={4}
                        {...this.props}
                    />
                </div>

                {this.state.content_editable === false ? (
                    <div className="alert alert-danger">
                        Je kunt de onderstaande gegevens van dit competentieprofiel niet veranderen of bijwerken omdat er al toetsmomenten op basis van dit
                        competentieprofiel zijn aangemaakt.
                    </div>
                ) : (
                    ""
                )}
                {bundleRows.length == 0 ? <div className="alert alert-danger">Er zijn nog geen toetsingen gekozen, ga terug naar de vorige stap.</div> : ""}

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="cp-resume">{bundleRows}</div>

                    <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                    <div className="form-group text-center">
                        <Link className="btn btn-light" to={"/competenceprofiles/edit/" + this.props.params.itemID + "/measurements"}>
                            Opslaan en terug naar toetsingen
                        </Link>
                        <button className="btn btn-primary" type="submit">
                            Opslaan en naar samenvatting
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}
